import React, { useState } from "react";
import { CheckCircle, XCircle } from "lucide-react";
import { motion } from "framer-motion";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {API_URL,FAST_API_URL} from "../api"

const CouponAndPayment = () => {
  const navigate = useNavigate();
  const [coupon, setCoupon] = useState("");
  const [isValidCoupon, setIsValidCoupon] = useState(null);
  const [discountApplied, setDiscountApplied] = useState(false);
  const [couponmessage, setcouponmessage] = useState("");

  const handleApplyCoupon = async () => {
    console.log("Applying coupon:", coupon);
  
    if (coupon.trim().toLowerCase() === "") {
      setIsValidCoupon(false);
      setDiscountApplied(false);
      return;
    }
  
    try {
      const response = await axios.post(`${API_URL}/coupon_payment_link`, {
        coupon_code: coupon.trim(),
        patient_id:localStorage.getItem("patient_id"),
        phone_number:localStorage.getItem("patient_phone_number"),
        user_type:"patient"
      });

      console.log(response.status)
  
      
      if (response.data && response.status===200){
        const payment_link=response.data.razorpay_link
        window.location.href = `https://rzp.io/i/${payment_link}` 
      }
      
      else {
        setIsValidCoupon(false);
        setDiscountApplied(false);
      }
    } catch (error) {
      if (error.status===300) {
        setcouponmessage(error.response.data.error)

        navigate("/doctor_details")
      } 


      if (error.status===401){
        setIsValidCoupon(false);
        setDiscountApplied(false);
        setcouponmessage(error.response.data.error)
      }

      if (error.status===404){
        setIsValidCoupon(false);
        setDiscountApplied(false);
        setcouponmessage("Invalid coupon code.")
        console.log(couponmessage)

      }
      if (error.status===400){
        setIsValidCoupon(false);
        setDiscountApplied(false);
        setcouponmessage(error.response.data.error)
        console.log(couponmessage)

      }
      if (error.status===402){
        setIsValidCoupon(false);
        setDiscountApplied(false);
        setcouponmessage(error.response.data.error)
        console.log(couponmessage)

      }
    }
  };
  // https://www.sandbox.paypal.com/cgi-bin/webscr?cmd=_express-checkout&token={{pay_link}}

  const handleProceedToPayment = async () => {
  try {
    const response = await axios.post(
      `${API_URL}/create_order_patient`,
      {
        patient_id: localStorage.getItem("patient_id"),
        phone_number: localStorage.getItem("patient_phone_number"),
        user_type: "patient",
      }
    );

    if (response.status === 200) {
      const options = {
        key: response.data.key, // Razorpay Key
        amount: response.data.amount,
        currency: "INR",
        name: "CarePlus",
        description: "Subscription Payment",
        order_id: response.data.order_id,

        prefill: {
          contact: localStorage.getItem("patient_phone_number"),
        },

        theme: {
          color: "#14b8a6",
        },

        handler: async function (paymentResponse) {
          try {
            await axios.post(
              `${API_URL}/payment-success`,
              {
                razorpay_payment_id:
                  paymentResponse.razorpay_payment_id,
                razorpay_order_id:
                  paymentResponse.razorpay_order_id,
                razorpay_signature:
                  paymentResponse.razorpay_signature,
                patient_id:
                  localStorage.getItem("patient_id"),
                user_id:paymentResponse.user_id,
                plan_type:paymentResponse.cached_subscription_type_data,
            user_type:paymentResponse.user_type
              }
            );

            alert("Payment Successful");
            navigate("/doctor_details");
          } catch (err) {
            console.error(err);
            alert("Payment verification failed");
          }
        },

        modal: {
          ondismiss: function () {
            console.log("Payment popup closed");
          },
        },
      };

      const razorpay = new window.Razorpay(options);

      razorpay.on("payment.failed", function (response) {
        alert(response.error.description);
      });

      razorpay.open();
    }
  } catch (error) {
    const status = error?.response?.status;

    if (status === 300) {
      navigate("/doctor_details");
      return;
    }

    if (status === 401) {
      alert(error?.response?.data?.error);
      return;
    }

    if (status === 402) {
      alert(error?.response?.data?.error);
      return;
    }

    console.error(error);
    alert("Unable to start payment");
  }
};

  return (
    <div className="w-full h-screen flex flex-col justify-center items-center bg-gradient-to-br from-teal-400 via-green-300 to-blue-200 p-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-lg w-full bg-white/80 backdrop-blur-lg shadow-xl rounded-3xl p-8"
      >
        <h2 className="text-3xl font-extrabold text-center text-gray-800 mb-6">
          🎟️ Redeem Coupon & Pay
        </h2>

        <div className="flex flex-col gap-5">
          <input
            placeholder="Enter your coupon code"
            value={coupon}
            required
            onChange={(e) => setCoupon(e.target.value)}
            className="w-full px-4 py-3 rounded-xl border border-gray-300 text-gray-700 focus:outline-none focus:ring-2 focus:ring-teal-500 transition"
          />
 
          <button
            onClick={handleApplyCoupon}
            className="bg-teal-600 hover:bg-teal-700 text-white rounded-xl py-3 font-semibold transition"
          >
            Apply Coupon
          </button>

          {isValidCoupon !== null && (
           
            <motion.div
           
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className={`flex items-center gap-2 text-sm font-medium ${
                isValidCoupon ? "text-green-600" : "text-red-600"
              }`}
            >
              {isValidCoupon ? (
                <CheckCircle size={20} />
              ) : (
                <XCircle size={20} />
              )}
              {isValidCoupon
                ? "Coupon applied successfully!"
                : couponmessage}
            </motion.div>
          )}
          <button
  onClick={handleProceedToPayment}
  className="border-2 border-teal-600 text-teal-700 font-semibold py-3 rounded-xl hover:bg-teal-100 transition"
>
  Proceed to Payment Without Coupon
</button>

          {/* <button
            onClick={handleProceedToPayment}
            className="border-2 border-teal-600 text-teal-700 font-semibold py-3 rounded-xl hover:bg-teal-100 transition"
          >
            Proceed to Payment Without Coupon
          </button> */}

          {/* {discountApplied && (
            <motion.p
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              className="text-green-700 text-center text-sm mt-2"
            >
              🎉 You've got <strong>20% off</strong> with coupon <strong>SAVE20</strong>!
            </motion.p>
          )} */}
        </div>
      </motion.div>
      
    </div>
  );
};

export default CouponAndPayment;
